/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable jsx-a11y/anchor-is-valid */

import React, { useState, useEffect } from 'react';
import { useSnackbar } from 'notistack';
import HelpIcon from '@material-ui/icons/Help';
import Checkbox from '@material-ui/core/Checkbox';
import { Tooltip, IconButton } from '@material-ui/core';
import { useHistory, useLocation, Redirect } from 'react-router-dom';

import PATH from 'routes/path';

import { createEventTracking } from 'services/api/tracking';
import { getCustomers, updateCustomer } from 'services/api/customers';

import { Button } from 'components/Button';
import { Title, Text } from 'components/Text';
import { ALERT_TYPE } from 'components/Alert';
import SnackMessage, { OPTIONS } from 'components/SnackMessage';

import HelpModal from './HelpModal';
import {
  Container,
  Header,
  BoxText,
  BoxOptin,
  BoxButtons,
} from './styles';

// Página de Documentos
const Documents = () => {
  const [checked, setChecked] = useState(false);
  const [openHelp, setOpenHelp] = useState(false);

  const history = useHistory();
  const location = useLocation();
  const { idCase } = location.state;
  const { enqueueSnackbar } = useSnackbar();

  const showHelp = () => {
    window.Intercom('trackEvent', 'LOIT FGTS documentos ajuda');
    setOpenHelp(true);
  };

  const closeHelp = () => setOpenHelp(false);

  useEffect(() => {
    document.title = 'Documentos - Revisão FGTS - LOIT';

    window.Intercom('trackEvent', 'LOIT FGTS documentos');
    createEventTracking('150 - documentos');
  }, []);

  const handleUpdateStep = async () => {
    const customer = await getCustomers();
    const payload = {
      ...customer.data[0],
      meta_data: {
        ...customer.data[0].meta_data,
        step: customer.data[0].meta_data.step && customer.data[0].meta_data.step > 4 ? customer.data[0].meta_data.step : 4,
        idCase,
      },
    };
    await updateCustomer(customer.data[0].id, payload);
    history.push({ pathname: PATH.DOWNLOAD, state: { idCase } });
  };

  const alertTermCheck = () => {
    enqueueSnackbar('Você precisa ler e aceitar o termo de ciência sobre os documentos para continuar.', {
      ...OPTIONS,
      content: (key, message) => (
        <SnackMessage
          id={key}
          message={message}
          variant={ALERT_TYPE.ERROR}
        />
      ),
    });
  };

  // Redireciona para Home, se não houver o parâmetro de id do caso
  if (!idCase) return <Redirect to={PATH.HOME} />;

  return (
    <Container>
      <Header>
        <Title secondary>Documentos</Title>
        {/* ICONE DE AJUDA */}
        <Tooltip title="Informação sobre documentos requisitados" arrow>
          <IconButton
            size="small"
            onClick={showHelp}
            disabled={openHelp}
            color="secondary"
          >
            Ajuda
            <HelpIcon />
          </IconButton>
        </Tooltip>
      </Header>
      {/* MODAL DE AJUDA */}
      {
        openHelp && (
          <HelpModal
            open={openHelp}
            onClose={closeHelp}
          />
        )
      }
      <BoxText>
        <Text>Parabéns!</Text>
      </BoxText>
      <BoxText>
        <Text>Seu KIT já foi enviado para seu e-mail com os seguintes arquivos:</Text>
      </BoxText>
      <BoxText>
        <ul>
          <li>Calculo.pdf</li>
          <li>Peticao.pdf</li>
        </ul>
      </BoxText>
      <BoxText>
        <Text>
          Para entrar com o seu pedido no Juizado Especial Federal (JEF) também serão necessários os seguintes documentos pessoais:
        </Text>
      </BoxText>
      <BoxText>
        <ul>
          <li>Documento de identidade (RG)</li>
          <li>Documento com CPF (CNH)</li>
          <li>Comprovante de endereço</li>
          <li>Documento com número de PIS</li>
        </ul>
      </BoxText>
      <BoxText>
        <Text>
          <strong>
            IMPORTANTE: Verifique o formato de entrega dos documentos conforme o Tribunal da sua região, no link a seguir:
          </strong>
        </Text>
      </BoxText>
      <BoxText>
        <strong>Acesse:</strong>
        <a
          target="_blank"
          rel="noreferrer"
          href="https://ajuda.tikal.tech/pt-BR/articles/4848739-entrando-com-o-processo-no-juizado-especial-federal"
        >
          {' '}
          “Orientações para entrar com a ação de revisão do FGTS”
        </a>
      </BoxText>
      <BoxOptin>
        <Checkbox
          id="disclaimer"
          size="small"
          checked={checked}
          onChange={(e) => setChecked(e.target.checked)}
        />
        <label htmlFor="disclaimer">
          Estou ciente de que devo providenciar os documentos mencionados para entrar com o processo no JEF
        </label>
      </BoxOptin>
      <BoxButtons>
        <Button
          onClick={
            !checked ? () => alertTermCheck() : () => handleUpdateStep()
          }
        >
          Continuar para o Kit
        </Button>
        <Button
          onClick={() => history.push(PATH.HOME)}
          variant="outlined"
          className="unset"
        >
          Voltar
        </Button>
      </BoxButtons>
    </Container>
  );
};

export default Documents;
